import { useTranslation } from 'react-i18next';

import * as St from './EstimateAndStoreInformation.styles';

import { getPromotionEndDate } from '~/UI/pages/OrderSummaryPage';
import { useSelectedStore } from '~/api/easy-estimator-api/stores-api/useSelectedStore';
import useEstimateSaver from '~/core/hooks/useEstimateSaver';
import { usePricedProductsContext } from '~/legacy/easy-estimator-page/context';

const EstimateAndStoreInformation = () => {
  const { t } = useTranslation();

  const { pricedProducts } = usePricedProductsContext();

  const selectedStore = useSelectedStore();

  const { getDisplayDates } = useEstimateSaver();
  const promotionEndDate = getPromotionEndDate(pricedProducts);
  const { quoteDate: displayedQuoteDate, expireDate: displayedExpireDate } =
    getDisplayDates(promotionEndDate ? new Date(promotionEndDate) : undefined);

  return (
    <St.Container>
      <St.Information>
        <St.Title>
          {t('ORDER_SUMMARY.ESTIMATE_SECTION.ESTIMATOR_INFORMATION_TITLE')}
        </St.Title>
        <span>
          {t('ORDER_SUMMARY.ESTIMATE_SECTION.ORDER.QUOTE')}{' '}
          {displayedQuoteDate.toLocaleDateString()}
        </span>
        <span>
          {t('ORDER_SUMMARY.ESTIMATE_SECTION.ORDER.EXPIRE')}{' '}
          {displayedExpireDate.toLocaleDateString()}
        </span>
      </St.Information>
      <St.Information>
        <St.Title>
          {t('ORDER_SUMMARY.ESTIMATE_SECTION.STORE_INFORMATION_TITLE')}{' '}
        </St.Title>
        <span>{selectedStore?.companyName}</span>
        <span>{selectedStore?.address}</span>
      </St.Information>
    </St.Container>
  );
};

export default EstimateAndStoreInformation;
